module.exports = __webpack_public_path__ + "media/images/products/products/f2-bd41a18564cc6b5b146cc54dc27a3a70.jpg";